import React, { useState, useEffect } from "react";
import useThemeSwitcher from "../hooks/useThemeSwitcher";
import {
  SunIcon,
  MoonIcon,
} from "./Icons";
// import LogoDesktop from '../../assets/SVG/LogoDesktop.png'

const navLinks = [
  { name: "Services", link: "#service-highlights" },
  { name: "Benefits", link: "#benefits" },
  { name: "Expert-Talk", link: "#expert" },
  { name: "Insights", link: "#insights" },
  { name: "Advisory", link: "#advisory" },
  { name: "Team", link: "#team" },
  { name: "About Us", link: "#about-us" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [bgChange, setBgChange] = useState(false);
  const [mode, setMode] = useThemeSwitcher();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Function to handle the scroll event
    const handleScroll = () => {
      if (window.scrollY > 100) {
        // Change 100 to the scroll threshold you want
        setBgChange(true);
      } else {
        setBgChange(false);
      }
    };

    // Adding scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function
    return () => {
      document.body.style.overflow = "unset";
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isOpen]);

  return (
    <nav
      className={`flex flex-row items-center  justify-between px-4 py-2  h-[70px] md:h-[112px]   fixed top-0 w-full  z-50 ${
        bgChange
          ? "bg-white dark:bg-dark  dark:text-white shadow-2xl shadow-[#4f1951] dark:shadow-light dark:shadow-lg border-b-dark border-[1px]"
          : ""
      } `}
    >
      {/* logo */}
      {/* <img src={Logo} className="w-[70px] md:hidden block h-[70px]" alt="svg" /> */}

      <h1 className="text-xl md:text-3xl font-extrabold font-mono leading-normal">
        <span className="dark:text-white text-[#4f1951]">Gogi</span>
        <span className="text-[#15A5E7]">Bus</span>{" "}
      </h1>

      {/* hiding it when less than 1080 px */}
      <div className="hidden flex-row xl:flex justify-between items-center w-[60%]">
        {navLinks.map((link, index) => (
          <a
            href={link.link}
            className={`text-[#4f1951] dark:text-white  hover:cursor-pointer
            ${mode === "light" ? "nav-link " : "dark-nav-link"}
             text-xl font-extrabold z-50`}
            key={index}
          >
            {link.name}
          </a>
        ))}
        <button
          onClick={() => setMode(mode === "light" ? "dark" : "light")}
          className={`ml-3 flex items-center justify-center rounded-full p-1 
          ${mode === "light" ? "bg-dark text-light" : "bg-light text-dark"}
         `}
        >
          {mode === "dark" ? (
            <SunIcon className={"fill-dark w-5 h-5"} />
          ) : (
            <MoonIcon className={"fill-dark w-5 h-5"} />
          )}
        </button>
      </div>

      {/* have to show hamburger menu button*/}
      <div className="relative flex flex-row xl:hidden items-center justify-center">
        <div
          className={`relative z-[100] flex flex-col w-8 h-6 justify-between items-center xl:hidden ${
            isOpen && "open"
          }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span
            className={`h-1 w-full dark:bg-white bg-dark transition-transform duration-300 ease-in-out ${
              isOpen ? "transform rotate-45 translate-y-2.5" : ""
            }`}
          ></span>
          <span
            className={`h-1 w-full dark:bg-white bg-dark transition-all duration-300 ease-in-out ${
              isOpen ? "opacity-0" : ""
            }`}
          ></span>
          <span
            className={`h-1 w-full dark:bg-white bg-dark transition-transform duration-300 ease-in-out ${
              isOpen ? "transform -rotate-45 -translate-y-2.5" : ""
            }`}
          ></span>
        </div>

        <button
          onClick={() => setMode(mode === "light" ? "dark" : "light")}
          className={`ml-3 flex items-center justify-center rounded-full p-1 
          ${mode === "light" ? "bg-dark text-light" : "bg-light text-dark"}
         `}
        >
          {mode === "dark" ? (
            <SunIcon className={"fill-dark w-8 h-8"} />
          ) : (
            <MoonIcon className={"fill-dark w-8 h-8"} />
          )}
        </button>

        <div
          className={`fixed top-0 left-0 w-full h-full  bg-white text-[#4f1951] transform ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform  duration-300 ease-in-out z-40 flex flex-col items-center justify-center dark:text-white dark:bg-dark`}
        >
          {navLinks.map((link, index) => (
            <a
              key={index}
              href={link.link}
              onClick={() => setIsOpen(!isOpen)}
              className="font-mono text-xl my-4"
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
